import { useIntl } from 'react-intl';

import { useRouter } from '@/hooks/useRouter';
import type { HeroProductListingType } from '@/integrations/contentful';
import { commonMessages } from '@/messages/common';

export const useGenerateBreadCrumbItems = ({
  heading,
  pageName,
  type,
}: {
  heading?: string | null;
  pageName?: string;
  type: HeroProductListingType;
}) => {
  const { asPath, locale, paths } = useRouter();
  const { formatMessage } = useIntl();

  const isStrapPath = asPath.startsWith(`/${locale}${paths.straps.asPath()}`);
  const isEyewearPath =
    type === 'all the eyewear' || asPath?.includes('sunglasses');

  const breadCrumbItems = [
    {
      label: formatMessage(commonMessages.home),
      target: paths.url(),
    },
    {
      label: isStrapPath
        ? formatMessage(commonMessages.straps)
        : isEyewearPath
          ? formatMessage(commonMessages.sunglasses)
          : formatMessage(commonMessages.theCollections),
      target: isStrapPath
        ? paths.straps.url()
        : isEyewearPath
          ? { pathname: '/sunglasses' }
          : paths.allCollections.url(),
    },
    {
      label:
        pageName?.toLocaleLowerCase() === 'all'
          ? formatMessage(commonMessages.all)
          : (heading ??
            (pageName
              ?.split('-')
              .map((word) => {
                return (word.charAt(0).toUpperCase() + word.slice(1)).replace(
                  /\bnfl\b/gi,
                  'NFL',
                );
              })
              .join(' ') as string)),
      target: {
        ...paths.watches.url(),
        pathname: isEyewearPath
          ? '/sunglasses' + (pageName ? `/${pageName}` : '')
          : `${paths.watches.url().pathname}${pageName ?? ''}`,
      },
    },
  ];
  return breadCrumbItems;
};
